import { xor } from 'lodash';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { selectImpactedEntities } from '../../modules/changeImpacts.js';

const mapStateToProps = (state, ownProps) => ({
  impactedOwners: selectImpactedEntities(ownProps.id)(
    state
  ).impactsOwners.filter((o) => !o.archived),
});

OwnersFilter.defaultProps = {
  selectedOwnerIds: [],
};

function OwnersFilter({ impactedOwners, selectedOwnerIds, navigateAction }) {
  const selectedCount = selectedOwnerIds.length;

  const handleSelect = useCallback(
    (ownerId) =>
      navigateAction({
        ownerIds: ownerId ? xor(selectedOwnerIds, [ownerId]) : [],
      }),
    [selectedOwnerIds]
  );

  const renderMenuItem = useCallback(
    (owner) => (
      <React.Fragment key={owner.id}>
        <MenuItem
          active={selectedOwnerIds.includes(owner.id)}
          eventKey={owner.id}
          onSelect={handleSelect}
        >
          {owner.fullName}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedOwnerIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Change Impact Owner</div>

      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="owners-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {impactedOwners.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(OwnersFilter);
